import { render, staticRenderFns } from "./VendorContactEdit.vue?vue&type=template&id=1d97c9f6&"
import script from "./VendorContactEdit.vue?vue&type=script&lang=js&"
export * from "./VendorContactEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports